import { apiSlice } from "app/api/apiSlice";

export const EMandiApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllFarmersList: builder.query({
      query: (pagination) => `/procurement/api/farmer-stock-detail`,
    }),

    getAggregationList: builder.query({
      query: ({ activeKey }) =>
        `/procurement/api/user-details/?entity_type=${activeKey}`,
    }),
    getEmandiReport: builder.query({
      query: ({
        selectedState,
        selectedDistrict,
        selectedCommodity,
        selectedMarket,
        startDate,
        endDate,
        pagination,
      }) =>
        `/api/v1/e-mandi/emandi-report?state=${selectedState}&district=${selectedDistrict}&commodity=${selectedCommodity}&market=${selectedMarket}&start_date=${startDate}&end_date=${endDate}&page=${pagination.page}&per_page=30`,

   
      }),
    getAllCommodities: builder.query({
      query: () => `/api/v1/e-mandi/commodities`,
    }),
    getAllMarketss: builder.query({
      query: ({ selectedState,selectedDistrict }) =>
        `/api/v1/e-mandi/market-master/?limit=2500&offset=0&state=${selectedState}&district=${selectedDistrict}`,
    }),
    getEmandiReportFilters: builder.query({
      query: ({
        selectedState,
        selectedDistrict,
        crops,
        start_date,
        end_date,
      }) =>
        `/api/v1/e-mandi/emandi-report?state=${selectedState}&district=${selectedDistrict}&commodity=${crops}&market=&start_date=${start_date}&end_date=${end_date}=&page=1000`,
    }),
    assignByAdminForFarmers: builder.mutation({
      query: ({ approvalId, payload }) => ({
        url: `api/v1/onboarding/farmer-aggrigation`,
        method: "PATCH",
        body: payload,
      }),
    }),
    getFarmerAdminTradeById: builder.query({
      query: ({ id }) => `api/v1/onboarding/farmer-aggrigation?id=${id}`,
    }),
    farmerAdminPostChat: builder.mutation({
      query: ({ payload }) => ({
        url: `api/v1/onboarding/farmer-negotiations`,
        method: "POST",
        body: payload,
      }),
    }),
    emandiLocationMaster: builder.query({
      query: () => `/api/v1/e-mandi/location-master`,
    }),
    emandiLocationMasterDistrict: builder.query({
      query: ({ selectedState }) =>
        `/api/v1/e-mandi/location-master?state=${selectedState}`,
    }),
    postAgreggationDetails: builder.mutation({
      query: ({ tradeId, payload }) => ({
        url: `api/v1/onboarding/farmer-aggrigation?trade_id=${tradeId}`,
        method: "PUT",
        body: payload,
      }),
    }),
    emandiYearApi: builder.query({
      query: () => `/api/v1/e-mandi/master/years/?is_enabled=true `,
    }),
  }),
});

export const {
  useGetAllFarmersListQuery,
  useGetAggregationListQuery,
  useGetEmandiReportQuery,
  useGetAllCommoditiesQuery,
  useGetAllMarketssQuery,
  useGetEmandiReportFiltersQuery,
  useAssignByAdminForFarmersMutation,
  useGetFarmerAdminTradeByIdQuery,
  useFarmerAdminPostChatMutation,
  useEmandiLocationMasterQuery,
  useEmandiLocationMasterDistrictQuery,usePostAgreggationDetailsMutation,useEmandiYearApiQuery
} = EMandiApiSlice;
